<app-metadata [graphName]="'local-procurement'"></app-metadata>
@if (data && informations ) {
  <div>
    <app-form
      [informations]="informations"
      [data]="data"
      [helptexts]="helptexts[0]"
      (dataSubmitted)="onData($event)"
    ></app-form>
  </div>
}
